export default __webpack_public_path__ + "static/media/vib_4.11fabf5a.png";